import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

// Auto-login silently with the seeded admin so the API works.
// The login UI is completely removed from the frontend.
// Fallback to defaults so the app works even if env vars aren't configured in production.
const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "admin@docs.app";
const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || "admin123";

async function silentLogin() {
  const { data } = await api.post("/auth/login", {
    email: ADMIN_EMAIL,
    password: ADMIN_PASSWORD,
  });
  if (data?.access_token) setToken(data.access_token);
  return data?.user || null;
}

export function AuthProvider({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await silentLogin();
      } catch (e) {
        // Silent login may fail if backend is unreachable; API calls will
        // surface a clearer 401 error later via getReadableError().
        console.warn("Silent login failed:", e);
      }
      if (!cancelled) setReady(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-white">
        <div className="label-eyebrow animate-pulse">Cargando...</div>
      </div>
    );
  }

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext) || {};
}
